/**
 * Primer compound from the good years, when everything was allowed to be atomic.
 */

import type { Affix } from '@/sim/items/affixContract';

export const ATOMIC_PRIMER = {
  id: 'atomicPrimer',
  slot: 'prefix',
  field: 'damage',
  direction: 1,
  label: 'Increased damage',
  nameWord: 'Atomic',
  ranges: {
    common: { min: 0.04, max: 0.08 },
    uncommon: { min: 0.08, max: 0.14 },
    rare: { min: 0.14, max: 0.22 },
    exotic: { min: 0.22, max: 0.32 },
  },
} as const satisfies Affix;
